import axios from 'axios'
import { usePage } from '@inertiajs/vue3'
import axiosInstance from '@/api/axios.js'
import { sendPlaintextCsrfToken } from '@/api/csrf.js'
import Pusher from 'pusher-js/dist/web/pusher.min.js'

// The reload re-reads the same browser cache, so a chunk that is broken rather than
// stale fails again and this loops forever. Retry once per tab.
window.addEventListener('vite:preloadError', () => {
    if (sessionStorage.getItem('vite:preloadRetried')) return
    sessionStorage.setItem('vite:preloadRetried', '1')
    window.location.reload()
})

window.Pusher = Pusher

/**
 * The app's axios instance sends the CSRF token twice: the XSRF-TOKEN cookie (copied by
 * axios) and the plaintext token from the Inertia `csrf_token` prop, which Laravel checks
 * first. The cookie alone is not enough: other MarketScale lanes write a cookie of the same
 * name for the whole `.marketscale.com` domain (SM-9775).
 */
window.axios = axiosInstance

// Inertia's router, and every module that imports axios directly, sends through the bare
// axios instance instead. Give it the plaintext token too; see api/csrf.js.
const inertiaPage = usePage()
sendPlaintextCsrfToken(axios, () => inertiaPage.props?.csrf_token)
